<div class="tt-c-reviews-list-utilities">
  <div class="tt-c-reviews-toolbar">
      <tt-listbox :model="sortBy"
                  @change="onSort"
                  class="tt-c-reviews-toolbar__sort"
                  :disabled="hasSearchTerm"
                  :label="$msg('reviewsList.sort')"
                  :multiSelect="false"
                  :options="sortField.options"
                  :subLabel="sortField.label"></tt-listbox>

      <label for="tt-c-reviews-list-search-field" class="tt-u-clip-hide" v-html="$msg('reviewsList.searchReviews')"></label>
      <tt-search-field class="tt-c-reviews-toolbar__search"
                       v-model="reviewsStore.searchTerm"
                       fieldId="tt-c-reviews-list-search-field"
                       :placeholder="$msg('reviewsList.searchReviews')"
                       :showSearchIcon="true"></tt-search-field>

      <tt-review-filters v-if="numFilters === 1"></tt-review-filters>
      <tt-button v-else-if="showFiltersToggle" type="toolbar" @click="toggleFilters" class="tt-c-reviews-toolbar__filters-toggle"><span class="tt-c-reviews-toolbar__filters-toggle-text" v-html="toggleFiltersText"></span><tt-icon name="controls" size="sm"></tt-icon></tt-button>
      
      <div class="tt-c-reviews-toolbar__spacer"></div>

      <tt-button v-if="!hideWriteReview && !isLaunchingWriteReview"
                 class="tt-c-reviews-toolbar__write-review"
                 type="primary"
                 @click="writeReview"
                 v-html="$msg('reviewsList.writeReview')"></tt-button>
      <div v-else-if="!hideWriteReview && isLaunchingWriteReview" class="tt-o-spinner tt-o-spinner--submit"></div>
  </div>
  <div v-if="showFilters" class="tt-c-reviews-filters-row tt-u-spacing--sm">
    <tt-review-filters></tt-review-filters>
  </div>
  <div v-show="appliedFilterOptions.length > 0" class="tt-c-reviews-applied-filters">
    <div class="tt-c-reviews-applied-filters__inner">
      <tt-button @click="clearAllFilters" type="compact-text" class="tt-c-reviews-applied-filters__clear" v-html="$msg('reviewsList.clearAll')"></tt-button>
      <tt-button v-for="filterOption in appliedFilterOptions"
                 type="chip"
                 class="tt-c-reviews-applied-filters__filter"
                 @click="removeFilter(filterOption.filter, filterOption.value)"
                 :aria-label="$msg('reviewsList.removeFilter', [filterOption.label])">
          <span class="tt-c-reviews-applied-filters__filter-text" v-html="filterOption.label"></span> <tt-icon name="close" size="xxs"></tt-icon>
      </tt-button>
    </div>
  </div>
</div>
